export default __webpack_public_path__ + "static/media/Patriotic-Memory-Wire-Bracelet.fc8c0d6d.jpg";